import {worker} from 'workerpool';
import {activities, calendar} from 'store';

worker({
  'goals.stats': ([state, milestones, allActivities, starting_date, target_date]) => {
    const result = {
      activities: {total: 0, completed: 0},
      milestones: {total: 0, completed: 0}
    };

    for (const milestone of milestones) {
      result.milestones.total++;
      result.milestones.completed += milestone.status === 'Completed' ? 1 : 0;
    }

    for (const activity of allActivities) {
      if (activities.type(activity) === 'activity') {
        if (activities.status(activity) !== 'On Hold') {
          result.activities.total++;
          result.activities.completed += activity.status === 'Completed' ? 1 : 0;
        }
      } else {
        for (const date of calendar.period({}, starting_date, target_date)) {
          if (!/On Hold|Expired|Future/.test(activities.status(activity, date))) {
            const match = calendar.occurance(state, {date})(activity);
            if (match) {
              result.activities.total++;
              result.activities.completed += match.status === 'Completed' ? 1 : 0;
            }
          }
        }
      }
    }

    return result;
  }
});
